import config from "lib/config";

export const SYSTEM_SETTING_SHOW_COURSE_IMAGE_PORTAL =
  "showcourseimageinportal";
export const SYSTEM_SETTING_ON = "1";

export const RECOMMENDED_COURSECATALOGUE_URL = `${config.urlRoot}activities/listactivities.aspx?inapp=1&rec=1`;
